// extracted by mini-css-extract-plugin
export default {"productGallery":"HQ-z","inQuickShop":"IQ-z"};